import { Box } from "@mui/material";
import SurveyBackButton from "../UserInput/Buttons/SurveyBackButton";
import SurveyButton from "../UserInput/Buttons/SurveyButton";
import SurveyNextButton from "../UserInput/Buttons/SurveyNextButton";

/**
 *
 * @param {object} props
 * @param {{ buttonBackgroundColor: string; buttonTextColor: string; }} props.colorTheme The theme for the button.
 * @param {boolean} [props.showFinishButton]
 * @param {boolean} [props.disableFinishButton]
 * @param {boolean} [props.isFinishButtonLoading]
 * @param {boolean} [props.showBackButton]
 * @param {() => void} props.handleNext
 * @param {() => void} props.handleBack
 * @param {() => void} props.handleFinish
 */
function SurveyButtonPanel({
    colorTheme,
    showFinishButton,
    disableFinishButton,
    isFinishButtonLoading,
    showBackButton,
    handleNext,
    handleBack,
    handleFinish,
}) {
    return (
        <Box display="flex" justifyContent="start" gap="27px">
            {showBackButton && <SurveyBackButton forceRounded={colorTheme.roundedButtons} handleOnClick={handleBack} />}

            {showFinishButton ? (
                <SurveyButton
                    size={{ fontSize: "14pt", paddingX: "14px", paddingY: "7px" }}
                    handleOnClick={handleFinish}
                    colorTheme={colorTheme}
                    disabled={disableFinishButton}
                    loading={isFinishButtonLoading}
                >
                    Get my score
                </SurveyButton>
            ) : (
                <SurveyNextButton
                    size={{ fontSize: "14pt", paddingX: "14px", paddingY: "7px" }}
                    handleOnClick={handleNext}
                    colorTheme={colorTheme}
                />
            )}
        </Box>
    );
}

export default SurveyButtonPanel;
